import axiosInstance from "../instance/axiosInstance";

class BillingAPI {
  static async getPlansList() {
    try {
      const response = await axiosInstance.get("/plans/list");
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async requestGracePeriod() {
    try {
      const response = await axiosInstance.post(
        "/billing/grace-period-request"
      );
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async autoSubscribeStatus(status) {
    try {
      const response = await axiosInstance.post(
        `/billing/auto-susbcription?status=${status}`
      );
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async upgradeOrgPlan(formData) {
    try {
      const response = await axiosInstance.post(
        `/billing/upgrade-plan`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}
export default BillingAPI;
